import $ from 'jquery';
import modaal from 'modaal';
import Cookies from 'js-cookie';
import slick from 'slick-carousel';

class Modal {
    constructor() {
        this.carouselSlideIndex = 0;
        this.trainingVideoTitle = '';
    }

    getTrainingVideoEmbedUrl(url) {
        if (!url) {
            return url;
        }

        const value = url.trim();

        try {
            const parsed = new URL(value, window.location.origin);
            const host = parsed.hostname.replace(/^www\./, '').toLowerCase();

            // youtu.be/<id>
            if (host === 'youtu.be') {
                const id = parsed.pathname.split('/').filter(Boolean)[0];
                if (id) {
                    return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
                }
            }

            // youtube.com/watch?v=<id>, /shorts/<id>, /embed/<id>, /live/<id>
            if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
                let id = '';

                if (parsed.pathname === '/watch') {
                    id = parsed.searchParams.get('v') || '';
                } else if (parsed.pathname.startsWith('/shorts/')) {
                    id = parsed.pathname.split('/')[2] || '';
                } else if (parsed.pathname.startsWith('/embed/')) {
                    id = parsed.pathname.split('/')[2] || '';
                } else if (parsed.pathname.startsWith('/live/')) {
                    id = parsed.pathname.split('/')[2] || '';
                }

                if (id) {
                    return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
                }
            }

            // vimeo.com/<id> or player.vimeo.com/video/<id>
            if (host === 'vimeo.com' || host === 'player.vimeo.com') {
                const segments = parsed.pathname.split('/').filter(Boolean);
                let id = segments[segments.length - 1] || '';

                if (id && /^\d+$/.test(id)) {
                    return `https://player.vimeo.com/video/${id}?autoplay=1`;
                }
            }
        } catch (e) {
            return value;
        }

        return value;
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.js-inline-modal').modaal();

        $('.js-internal-video').modaal({
            type: 'inline',
            custom_class: 'modaal-video',
            width: 930
        });

        $('.js-video').modaal({
            type: 'video',
            width: 930
        });

        $('.image-modal').modaal({
            type: 'image',
            width: 930
        });

        if ($('.carousel-modal').length) {
            $('.carousel-modal').modaal({
                type: 'inline',
                custom_class: 'carousel-modaal',
                before_open: (e) => {
                    let $clicked = $(e.currentTarget);
    
                    this.carouselSlideIndex = parseInt($clicked.attr('data-slide'), 10);
                },
                after_open: () => {
                    $('<button class="image-gallery-prev"><span class="sr-only">Previous</span><i class="fas fa-arrow-left"></i></button>').appendTo('.modaal-content-container');
                    $('<button class="image-gallery-next"><span class="sr-only">Next</span><i class="fas fa-arrow-right"></i></button>').appendTo('.modaal-content-container');
    
                    $('.modaal-container .image-gallery-modal').on('init', (e, slick) => {
                        $('.modaal-container .spinner-wrapper').toggleClass('d-none');
                        $('.modaal-container .image-gallery-modal').toggleClass('d-none');
                    });
    
                    $('.modaal-container .image-gallery-modal').slick({
                        mobileFirst: true,
                        dots: false,
                        infinite: true,
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        prevArrow: $('.image-gallery-prev'),
                        nextArrow: $('.image-gallery-next')
                    });
    
                    $('.modaal-container .image-gallery-modal').slick('slickGoTo', this.carouselSlideIndex, false);
                },
                before_close: () => {
                    $('.modaal-container .image-gallery-modal').slick('unslick');
                    $('.image-gallery-prev').remove();
                    $('.image-gallery-next').remove();
    
                    $('.modaal-container .image-gallery-modal').off('init');
    
                    $('.modaal-container .spinner-wrapper').toggleClass('d-none');
                    $('.modaal-container .image-gallery-modal').toggleClass('d-none');
                }
            });
        }

        $('.card-video').modaal({
            type: 'iframe',
            width: 930,
            source: (elem, src) => {
                src = $(elem).attr('href');
                return src;
            }
        });

        $('.js-training-video').modaal({
            type: 'iframe',
            width: 930,
            custom_class: 'training-video-modaal',
            before_open: (e) => {
                const $clicked = $(e.currentTarget);
                this.trainingVideoTitle = ($clicked.attr('data-video-title') || '').trim();
            },
            source: (elem, src) => {
                src = $(elem).attr('href');
                return this.getTrainingVideoEmbedUrl(src);
            },
            after_open: () => {
                const title = (this.trainingVideoTitle || '').trim();
                const $outer = $('.modaal-outer-wrapper:visible').last();
                const $inner = $outer.find('.modaal-inner-wrapper').first();

                if (!$outer.length || !$inner.length) {
                    return;
                }

                if ($inner.find('.training-video-modal__header').length) {
                    return;
                }

                const $close = $outer.find('button.modaal-close').first();
                const $header = $('<div class="training-video-modal__header" role="presentation"></div>');

                if (title) {
                    $('<div class="training-video-modal__title" role="heading" aria-level="2"></div>')
                        .text(title)
                        .appendTo($header);
                } else {
                    $('<div class="training-video-modal__title" aria-hidden="true"></div>').appendTo($header);
                }

                if ($close.length) {
                    $header.append($close);
                }

                $inner.prepend($header);
            }
        });

        // Close when clicking Modaal overlay
        $(document).on('click', (e) => {
            if ($(e.target).hasClass('modaal-outer-wrapper')) {
                $('.image-modal').modaal('close');
                $('.js-video').modaal('close');
                $('.js-inline-modal').modaal('close');
                $(`.carousel-modal[data-slide=${this.carouselSlideIndex}]`).modaal('close');
                $('.card-video').modaal('close');
                $('.js-training-video').modaal('close');
            }
        });

        $('.js-go-to-nfl').on('click', e => {
            window.location.href = 'https://www.nfl.com/causes/play60/';
        });

        
        $('.ss-modal-dialog-close').on('click', () => {
            $('#autoModal').modaal('close');
        });


        const homepagePopupHasImage = $('.ss-modal-wrapper').hasClass('has-image');
        $('#autoModal').modaal({
            type: 'inline',
            custom_class: `ss-modal-box homepage-popup ${homepagePopupHasImage ? 'has-image' : ''}`,
            vertical_align: 'middle',
            after_close: () => {
                switch ($('#autoModal').attr('href')) {
                    case '#ss-cookie-modal':
                        Cookies.set('hideRegistrationModal', 'true', { expires: 30 });
                        break;
                    case '#homepopup-cookie-modal':
                        sessionStorage.setItem('hideCookieModal', 'true');
                        break;
                    default:
                        break;
                }
            }
        });

        switch ($('#autoModal').attr('href')) {
            case '#ss-cookie-modal':
                if (Cookies.get('hideRegistrationModal') !== 'true') {
                    $('#autoModal').modaal('open');
                }
                break;
            case '#homepopup-cookie-modal':
                if (sessionStorage.getItem('hideCookieModal') !== 'true') {
                    $('#autoModal').modaal('open');
                }
                break;
            default:
                break;
        }
    }
}

export default Modal;

$(() => {
    const modal = new Modal();
    modal.init();
});
